import { render, staticRenderFns } from "./PremiumDialog.vue?vue&type=template&id=1d462d83&scoped=true"
import script from "./PremiumDialog.vue?vue&type=script&lang=js"
export * from "./PremiumDialog.vue?vue&type=script&lang=js"
import style0 from "./PremiumDialog.vue?vue&type=style&index=0&id=1d462d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d462d83",
  null
  
)

export default component.exports